import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  loanLog: {},
  currentPage: 1,
  searchQuery: '',
  branchfilter: [],
};

const loanLogPayloadSlice = createSlice({
  name: 'loanLogValue',
  initialState,
  reducers: {
    setLoanLogValue: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    resetLoanLogValue: () => initialState,
  },
});

export const {setLoanLogValue, resetLoanLogValue} = loanLogPayloadSlice.actions;

export default loanLogPayloadSlice.reducer;
